<template>
    <div id="app">
        <div class="intro flex flex-col w-text-block mx-auto h-screen">
            <ul>
                <li>
                    <small>Indicadores históricos </small>
                    <a @click="jumpTo(1)">Número acumulado de projetos apoiados pela FAPESP no período de 1962 a 2021, por tipo de fomento </a>
                </li>
                <li><a @click="jumpTo(2)">Número total de pessoas beneficiadas por projetos da FAPESP no período de 1962 a 2021</a></li>
                <li><a @click="jumpTo(3)">Número acumulado de projetos apoiados pela FAPESP com colaboração internacional, 1962-2021</a></li>
                <li><a @click="jumpTo(4)">Desembolsos acumulados da FAPESP por modalidade de fomento à pesquisa</a></li>
                <li><a @click="jumpTo(5)">Desembolsos anuais da FAPESP por objetivo do fomento, 2018-2021 </a></li>
                <li><small>Publicações científicas</small> <a @click="jumpTo(6)">Número de publicações científicas </a></li>
                <li><a @click="jumpTo(7)">Publicação científica com colaboração internacional </a></li>
                <li><a @click="jumpTo(8)">Propriedade intelectual</a></li>
                <li>
                    <small>Pequenas empresas </small>
                    <a @click="jumpTo(9)">Número de projetos e de empresas apoiadas pelo programa Pipe </a>
                </li>
                <li><a @click="jumpTo(10)">Geografia do programa Pipe </a></li>
                <li><a @click="jumpTo(11)">Mapa de distribuição do fomento (auxílios Pipe) por munícipio </a></li>
                <li><small>Formação de recursos humanos </small> <a @click="jumpTo(12)">Bolsas regulares no país e bolsas-estágio de pesquisa no exterior </a></li>
                <li><small>Colaboração internacional </small><a @click="jumpTo(13)">Projetos financiados pela Fapesp com instituições de outros países</a></li>
                <li><a @click="jumpTo('fontes')">Fontes</a></li>
            </ul>
        </div>

        <div class="main">
            <div class="main__graphic flex flex-col-reverse w-screen">
                <!-- <div>{{ currStep }}asdas</div> -->
                <div v-if="currStep == 1">
                    <Indicator1 class="w-screen h-screen"></Indicator1>
                </div>
                <div v-if="currStep == 2">
                    <Indicator2></Indicator2>
                </div>
                <div v-if="currStep == 2">
                    <Indicator2></Indicator2>
                </div>
                <div v-if="currStep == 3">
                    <Indicator3></Indicator3>
                </div>
                <div v-if="currStep == 4">
                    <Indicator4></Indicator4>
                </div>
                <div v-if="currStep == 5">
                    <Indicator5></Indicator5>
                </div>
                <div v-if="currStep == 6">
                    <Indicator6></Indicator6>
                </div>
                <div v-if="currStep == 7">
                    <Indicator7></Indicator7>
                </div>
                <div v-if="currStep == 8">
                    <Indicator8></Indicator8>
                </div>
                <div v-if="currStep == 9">
                    <Indicator9></Indicator9>
                </div>
                <div v-if="currStep == 10">
                    <Indicator10></Indicator10>
                </div>
                <div v-if="currStep == 11">
                    <Indicator11></Indicator11>
                </div>
                <div v-if="currStep == 12">
                    <Indicator12></Indicator12>
                </div>
                <div v-if="currStep == 13">
                    <Indicator13></Indicator13>
                </div>
                <div v-if="currStep == 14">
                    <Indicator14></Indicator14>
                </div>
            </div>
            <Scrollama :debug="false" :offset="0.5" @step-enter="({ element }) => (currStep = element.dataset.stepNo)" class="main__scrollama w-screen">
                <div class="step" data-step-no="1" ref="step_1">
                    <div class="step_inner">
                        <h2>Número acumulado de projetos apoiados pela FAPESP no período de 1962 a 2021</h2>
                        <h3>Por tipo de fomento</h3>
                        <p>
                            O procedimento de numeração única dos projetos submetidos à Fapesp (Processos Fapesp) teve início na década de 1980. Nos registros anteriores a esta data um mesmo número de processo poderia ser atribuído a mais
                            de um projeto com diferentes beneficiários, responsáveis e/ou linhas de fomento. Para esta série histórica foram utilizados os conceitos: projeto com diferentes beneficiários, responsáveis e/ou linhas de fomento,
                            para os registros compreendidos no período 1962-1991; e processos para os registros compreendidos no período de 1992-2021
                        </p>
                    </div>
                </div>
                <div class="step" data-step-no="2" ref="step_2">
                    <div class="step_inner">
                        <h2>Número total de pessoas beneficiadas por projetos da FAPESP no período de 1962 a 2021</h2>
                        <p>
                            Este indicador é composto por todas as pessoas que foram beneficiadas por projetos de bolsas ou auxílios à pesquisa financiados pela FAPESP. Esses dados são preliminares, uma vez que, para os projetos aprovados
                            no período de 1962 a 1991, não há indicação do CPF dos beneficiários e responsáveis. Assim, estimou-se o número total das pessoas beneficiadas, ou seja, que tiveram acesso ao fomento da FAPESP.
                        </p>
                        <p>
                            Foram contabilizados os beneficiários, responsáveis, pesquisadores principais nos auxílios à pesquisa concedidos e os pesquisadores visitantes. Não foram contabilizados os supervisores do exterior das bolsas
                            Bepe, Bolsa regular no exterior – Programa Reserva Técnica de Bolsa – Aperfeiçoamento, Bolsa regular no exterior – Doutorado, Bolsa no Exterior – Novas Fronteiras e Bolsa no Exterior Pesquisa
                        </p>
                    </div>
                </div>
                <div class="step" data-step-no="3" ref="step_3">
                    <div class="step_inner">
                        <h2>Número acumulado de projetos apoiados pela Fapesp com colaboração internacional, 1962-2021</h2>
                        <p>
                            O procedimento de numeração única dos projetos submetidos à Fapesp (Processos Fapesp) teve início na década de 1980. Nos registros anteriores a esta data um mesmo número de processo poderia ser atribuído a mais
                            de um projeto com diferentes beneficiários, responsáveis e/ou linhas de fomento. Para esta série histórica foram utilizados os conceitos: projeto com diferentes beneficiários, responsáveis e/ou linhas de fomento,
                            para os registros compreendidos no período 1962-1991; e processos para os registros compreendidos no período de 1992-2021. 2. Projetos financiados pela Fapesp em colaboração com pesquisadores de outros países.
                            Foram incluídos os Auxílios à Pesquisa: Organização de Reunião Científica (exterior); Participação em Reunião Científica (exterior); Pesquisador Visitante (exterior) e Publicações (exterior). E as Bolsas no
                            Exterior: Aperfeiçoamento; Complementação; Mestrado; Doutorado; Pós-Doutorado; Pós-Graduação; Participação em Curso; Bolsa Estágio de Pesquisa no Exterior (Bepe) Iniciação Científica; Bolsa Estágio de Pesquisa no
                            Exterior (Bepe) Mestrado; Bolsa Estágio de Pesquisa no Exterior (Bepe); Doutorado; Bolsa Estágio de Pesquisa no Exterior (Bepe) Doutorado Direto; Bolsa Estágio de Pesquisa no Exterior (Bepe) Pós-Doutorado; Bolsa
                            de Pesquisa no Exterior (BPE) e Novas Fronteiras. Além das Chamadas Internacionais
                        </p>
                    </div>
                </div>
                <div class="step" data-step-no="4" ref="step_4">
                    <div class="step_inner">
                        <h2>Desembolsos acumulados da Fapesp por modalidade de fomento à pesquisa</h2>
                        <h3>R$ 1.000.000 em valores de 2021 (IGP-DI)</h3>
                    </div>
                </div>
                <div class="step" data-step-no="5" ref="step_5">
                    <div class="step_inner">
                        <h2>Desembolsos anuais da Fapesp por objetivo do Fomento 2018-2021</h2>
                        <h3>Objetivos e estratégias de pesquisa</h3>
                    </div>
                </div>
                <div class="step" data-step-no="6" ref="step_6">
                    <div class="step_inner">
                        <h2>Distribuição dos valores desembolsados pela FAPESP por objetivo do fomento</h2>
                        <h3>Em %</h3>
                    </div>
                </div>
                <div class="step" data-step-no="7" ref="step_7">
                    <div class="step_inner">
                        <h2>Número de publicações científicas 2010-2021</h2>
                        <h3>Indexadas na WoS — 1980 a 2021</h3>
                        <p>
                            Dados de anos anteriores não foram utilizados no gráfico devido à grande flutuação das informações, provavelmente relacionadas às dificuldades de identificar os processos Fapesp nas publicações científicas
                            indexadas na base Web of Science.
                        </p>
                        <ol>
                            <li>1. Foram considerados apenas os documentos dos tipos: artigos, revisões e trabalhos em eventos científicos.</li>
                            <li>2. Publicações com pelo menos um autor vinculado a instituições localizadas no Brasil.</li>
                            <li>3. Publicações com pelo menos um autor vinculado a instituições localizadas em São Paulo.</li>
                            <li>4. Publicações com apoio da Fapesp</li>
                        </ol>
                    </div>
                </div>
                <div class="step" data-step-no="8" ref="step_8">
                    <div class="step_inner">
                        <h2>Publicação científica com colaboração internacional</h2>
                        <h3>Percentual de publicações científicas<sup>1</sup> em colaboração com autores de outros países, Brasil<sup>2</sup>, São Paulo<sup>3</sup>, Fapesp<sup>4</sup> em %</h3>
                    </div>
                </div>
                <div class="step" data-step-no="9" ref="step_9">
                    <div class="step_inner">
                        <h2>Número de pedidos de patentes de processos FAPESP, por ano do depósito – 1990-2020</h2>
                    </div>
                </div>
                <div class="step" data-step-no="10" ref="step_10">
                    <div class="step_inner">
                        <h2>Número de projetos e de empresas apoiadas pelo programa Pipe, 1998-2022</h2>
                        <ol>
                            <li>Foram analisados os processos concedidos com termo de outorga assinado na data da extração.</li>
                            <li>Foram excluídos os processos que na data da extração não estavam com o TO assinado ou que foram cancelados após o despacho.</li>
                            <li>Uma empresa pode ter mais de um projeto apoiado pela Fapesp.</li>
                        </ol>
                    </div>
                </div>
                <div class="step" data-step-no="11" ref="step_11">
                    <div class="step_inner">
                        <h2>Geografia do programa Pipe 15 cidades mais contempladas pelos projetos (auxílios e bolsas PE) do Programa Pipe</h2>
                        <p>
                            Foram analisados os processos concedidos com termo de outorga assinado na data da extração. Foram excluídos os processos que na data da extração não estavam com o TO assinado ou que foram cancelados após o
                            despacho. Uma empresa pode ter mais de um projeto apoiado pela FAPESP. Mapa de distribuição dos projetos Pipe contratados pela FAPESP (valor acumulado).
                        </p>
                    </div>
                </div>
                <div class="step" data-step-no="12" ref="step_12">
                    <div class="step_inner">
                        <h2>Bolsas Regulares no País e Bolsas Estágio de Pesquisa no Exterior 1992-2022</h2>
                        <h3>Número acumulado de bolsas de formação de recursos humanos, por ano do início da vigência do processo segundo o sexo do beneficiário, 1992-2022</h3>
                        <p>As bolsas de formação de RH incluem as modalidades Bolsas de Formação de Recursos Humanos, nas modalidades Iniciação Científica (45%), Mestrado (23%), Doutorado e Doutorado Direto (20%) e Pós-Doutorado (12%).</p>
                    </div>
                </div>
                <div class="step" data-step-no="13" ref="step_13">
                    <div class="step_inner">
                        <h2>Bolsas Regulares no País e Bolsas Estágio de Pesquisa no Exterior 1992-2022</h2>
                        <h3>Grande área</h3>
                    </div>
                </div>
                <div class="step" data-step-no="14" ref="step_14">
                    <div class="step_inner">
                        <h2>Projetos financiados pela Fapesp com instituições de outros países</h2>
                    </div>
                </div>
            </Scrollama>
        </div>

        <div class="outro" ref="step_fontes">Fontes:</div>
    </div>
</template>

<script>
import 'intersection-observer'
import Scrollama from 'vue-scrollama'
import Indicator1 from '@/components/Summary/Indicator1.vue'
import Indicator2 from '@/components/Summary/Indicator2.vue'
import Indicator3 from '@/components/Summary/Indicator3.vue'
import Indicator4 from '@/components/Summary/Indicator4.vue'
import Indicator5 from '@/components/Summary/Indicator5.vue'
import Indicator6 from '@/components/Summary/Indicator6.vue'
import Indicator7 from '@/components/Summary/Indicator7.vue'
import Indicator8 from '@/components/Summary/Indicator8.vue'
import Indicator9 from '@/components/Summary/Indicator9.vue'
import Indicator10 from '@/components/Summary/Indicator10.vue'
import Indicator11 from '@/components/Summary/Indicator11.vue'
import Indicator12 from '@/components/Summary/Indicator12.vue'
import Indicator13 from '@/components/Summary/Indicator13.vue'
import Indicator14 from '@/components/Summary/Indicator14.vue'

export default {
    components: {
        Scrollama,
        Indicator1,
        Indicator2,
        Indicator3,
        Indicator4,
        Indicator5,
        Indicator6,
        Indicator7,
        Indicator8,
        Indicator9,
        Indicator10,
        Indicator11,
        Indicator12,
        Indicator13,
        Indicator14,
    },
    data() {
        return {
            currStep: null,
        }
    },
    methods: {
        jumpTo: function (target) {
            // console.log('ok')
            // console.log(this.$refs.laila)
            console.log(this.$refs.step_10)
            let idx = 'step_' + target
            this.$refs[idx].scrollIntoView({ behavior: 'smooth' })
        },
    },
}
</script>

<style lang="postcss" scoped>
.intro small {
    @apply block uppercase;
}
.intro li {
    @apply mb-4;
}
.intro a {
    @apply font-semibold text-lg cursor-pointer;
}
.outro {
    padding: 20vh;
}

.main {
    display: flex;
}

.main__graphic {
    flex: 1;
    height: 80vh;
    top: 10vh;
    position: sticky;
}
.main__scrollama {
    flex: 1;
    width: 100%;
}

.main__graphic {
    height: 100%;
    width: 59vw;

    font-size: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.step {
    height: 100vh;
    width: 100vw;

    display: flex;
    flex-direction: column;
}
.step:last-child {
    margin-bottom: 0;
}
.step_inner {
    z-index: 99;
    @apply mx-auto w-text-block bg-offwhite border-2 border-black p-4 my-auto;
}
.step_inner h2 {
    @apply mt-0 mb-2 font-bold w-full;
}
.step_inner h3 {
    @apply text-xl;
}
.step_inner p {
    @apply w-full m-0 text-lg mt-4;
}
.step_inner p:first-of-type::first-letter {
    @apply border-0 float-none font-normal text-lg m-0 p-0;
}
</style>
